import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

const NO_RETRY = ["/auth/login", "/auth/register", "/auth/refresh"];
let refreshing = null;

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const orig = error.config;
    if (error.response?.status === 401 && orig && !orig._retry && !NO_RETRY.some((u) => orig.url.includes(u))) {
      orig._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(orig);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (detail && detail.code === "plan_ai") return "PLAN_AI";
  if (detail && detail.code === "plan_invoices") return "PLAN_INVOICES";
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const errMsg = (e) => formatApiErrorDetail(e?.response?.data?.detail) || e?.message;

export const planError = (e) => {
  const m = errMsg(e);
  return m === "PLAN_AI" || m === "PLAN_INVOICES" ? m : null;
};

export async function streamChat(message, lang, onDelta) {
  const doFetch = () =>
    fetch(`${API}/ai/chat`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ message, lang }),
    });
  let res = await doFetch();
  if (res.status === 401) {
    await api.post("/auth/refresh");
    res = await doFetch();
  }
  if (res.status === 402) throw new Error("PLAN_AI");
  if (!res.ok || !res.body) throw new Error("chat failed");
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  while (true) {
    const { done, value } = await reader.read();
    if (done) return;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      const line = p.replace(/^data: /, "");
      if (line === "[DONE]") return;
      let d;
      try {
        d = JSON.parse(line);
      } catch {
        continue;
      }
      if (d.error) throw new Error(d.error);
      if (d.delta) onDelta(d.delta);
    }
  }
}
